import {
  InfoCircleFilled,
  InfoCircleOutlined,
  SafetyCertificateTwoTone,
  WarningFilled,
  WarningOutlined,
} from '@ant-design/icons'
import { Tooltip, TooltipProps } from 'antd'
import classnames from 'classnames'
import * as React from 'react'

import styles from './InfoTooltip.module.css'

type InfoTooltipProps = {
  icon?: React.ReactElement
  iconStyle?: any
  positioning?: 'left' | 'right'
  status?: 'info' | 'warning' | 'certified'
  type?: 'default' | 'primary'
  viewMode?: 'filled' | 'outlined'
} & TooltipProps

export function InfoTooltip({
  icon,
  iconStyle,
  positioning = 'left',
  status = 'info',
  type = 'default',
  viewMode = 'outlined',
  ...tootltipProps
}: InfoTooltipProps): JSX.Element {
  const className = classnames(
    styles['info-tooltip'],
    styles[positioning],
    styles[type]
  )

  const Icon = getIcon(status, viewMode)
  return (
    <Tooltip className={className} {...tootltipProps}>
      <span style={iconStyle}>{icon || <Icon />}</span>
    </Tooltip>
  )
}

function getIcon(status, style): React.FC {
  if (status === 'certified') {
    return SafetyCertificateTwoTone
  }
  if (status === 'warning') {
    return style === 'filled' ? WarningFilled : WarningOutlined
  }

  return style === 'filled' ? InfoCircleFilled : InfoCircleOutlined
}
